export const isElement = d => d instanceof Element;

export const checkElements = (...elms) =>
  elms.reduce((check, elm) => {
    if (!check) return check;
    return isElement(elm);
  }, true);
